import React, { useState } from 'react';
import { Button } from '@/shared/ui/Button';
import { Input } from '@/shared/ui/Input';
import { validateEmail } from '@/shared/utils/validation';
import { useLogin } from '../hooks/useLogin';
import { MagicLinkSent } from './MagicLinkSent';
import styles from './LoginForm.module.css';

export function LoginForm() {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState<string | null>(null);
  const { sendMagicLink, isLoading, isSent, error } = useLogin();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const validationError = validateEmail(email);
    if (validationError) {
      setEmailError(validationError);
      return;
    }
    setEmailError(null);
    await sendMagicLink(email);
  };

  if (isSent) {
    return <MagicLinkSent email={email} />;
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>Welcome back</h1>
        <p className={styles.subtitle}>Enter your email to sign in with a magic link</p>
      </div>

      <form onSubmit={handleSubmit} className={styles.form}>
        <Input
          label="Email address"
          type="email"
          placeholder="you@practice.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          error={emailError || error || undefined}
          fullWidth
          autoFocus
          autoComplete="email"
        />

        <Button
          type="submit"
          variant="primary"
          loading={isLoading}
          fullWidth
          size="lg"
        >
          Send magic link
        </Button>
      </form>

      <p className={styles.note}>
        We'll send you a secure sign-in link. No password needed.
      </p>
    </div>
  );
}
